import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { body2Bold, body3Regular } from "shared/styles/typography";

import { ViewAllProps } from "./types";

const ViewAll = ({ roles }: ViewAllProps) => {
    const { gray700, white } = colors;

    const { t } = useTranslation();

    return (
        <div>
            <TooltipGeneral
                title={
                    <ul
                        css={css({
                            maxHeight: "199px",
                            maxWidth: "246px",
                            overflowY: "auto",
                            marginRight: "-16px",
                            paddingRight: "16px",

                            "& > li + li": {
                                marginTop: "24px"
                            },

                            "&::-webkit-scrollbar-thumb": {
                                borderColor: gray700
                            }
                        })}
                    >
                        {roles.map(({ id, name, description }) => (
                            <li key={id}>
                                <div css={[body2Bold, { color: white }]}>
                                    {name}
                                </div>

                                {description && (
                                    <div css={[body3Regular, { color: white }]}>
                                        {description}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                }
                placement={TOOLTIP_PLACEMENT.Right}
                removeArrow
            >
                <span>
                    <TextLink size={TEXT_LINK_SIZES.Small}>
                        {t("Table##view all roles", {
                            count: roles.length
                        })}
                    </TextLink>
                </span>
            </TooltipGeneral>
        </div>
    );
};

export default ViewAll;
